export type NotificationKind =
  | 'new-lead'
  | 'reply'
  | 'app-submitted'
  | 'ai-review'
  | 'overdue'
  | 'clear-to-close'

export type Notification = {
  id: string
  kind: NotificationKind
  title: string
  body: string
  time: string
  unread: boolean
  to: string
}

export const notifications: Notification[] = [
  {
    id: 'n1',
    kind: 'new-lead',
    title: 'Sandra Kim assigned to you',
    body: 'Bankrate · NJ · $505,000 — call within 5 minutes',
    time: '1m ago',
    unread: true,
    to: '/leads',
  },
  {
    id: 'n2',
    kind: 'new-lead',
    title: 'Danielle Ferro assigned to you',
    body: 'Bankrate · FL · $385,000 — untouched',
    time: '3m ago',
    unread: true,
    to: '/leads',
  },
  {
    id: 'n3',
    kind: 'app-submitted',
    title: 'Aaron Whitfield submitted his application',
    body: 'LN-1191 created — review the file',
    time: '22m ago',
    unread: true,
    to: '/loans',
  },
  {
    id: 'n4',
    kind: 'ai-review',
    title: '2 documents matched to conditions',
    body: 'LN-1191 — paystubs and bank statements need your review',
    time: '30m ago',
    unread: true,
    to: '/loans',
  },
  {
    id: 'n5',
    kind: 'reply',
    title: 'Robert Silva replied',
    body: '“Talked it over — call me at 11:30”',
    time: '54m ago',
    unread: false,
    to: '/follow-ups',
  },
  {
    id: 'n6',
    kind: 'overdue',
    title: 'Follow-up overdue',
    body: 'Grace Lindqvist · LN-1176 stalled 9 days in underwriting',
    time: '2h ago',
    unread: false,
    to: '/loans',
  },
  {
    id: 'n7',
    kind: 'clear-to-close',
    title: 'Devon Price is Clear to Close',
    body: 'LN-1168 — closing Aug 4',
    time: '3h ago',
    unread: false,
    to: '/loans',
  },
]
